// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"1a1532e8","175":"11942152","231":"d1dafe59","296":"1a1532e8","399":"1a1532e8","498":"1a1532e8","780":"1a1532e8","945":"d1dafe59"}[chunkId] + ".chunk.css";
};